import { __extends } from "tslib";
import React from 'react';
import PropTypes from 'prop-types';
import { isValidExactUrl } from 'wix-rich-content-common';
import { officialEmotes } from '../official-emotes';
import cleanLinkSrc from '../../../../utils/xss/cleanLinkSrc';
var OfficialEmoteViewer = /** @class */ (function (_super) {
    __extends(OfficialEmoteViewer, _super);
    function OfficialEmoteViewer() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    OfficialEmoteViewer.prototype.render = function () {
        var componentData = this.props.componentData;
        var emoteCode = componentData.emote.trim();
        if (!officialEmotes[emoteCode]) {
            return null;
        }
        var emote = officialEmotes[emoteCode];
        return (React.createElement("img", { src: "https://e.deviantart.net/emoticons".concat(emote.src), alt: emote.name, width: emote.width, height: emote.height, style: { imageRendering: 'pixelated' }, loading: "lazy" }));
    };
    OfficialEmoteViewer.propTypes = {
        componentData: PropTypes.object.isRequired,
        theme: PropTypes.object,
    };
    return OfficialEmoteViewer;
}(React.Component));
var CommunityEmoteViewer = /** @class */ (function (_super) {
    __extends(CommunityEmoteViewer, _super);
    function CommunityEmoteViewer() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    CommunityEmoteViewer.prototype.render = function () {
        var componentData = this.props.componentData;
        if (!componentData.src) {
            return null;
        }
        if (componentData.url && isValidExactUrl(componentData.url)) {
            return (React.createElement("a", { href: cleanLinkSrc(componentData.url), title: componentData.title },
                React.createElement("img", { src: cleanLinkSrc(componentData.src), alt: componentData.title, width: componentData.width, height: componentData.height, loading: "lazy" })));
        }
        return (React.createElement("img", { src: cleanLinkSrc(componentData.src), alt: componentData.title, width: componentData.width, height: componentData.height, loading: "lazy" }));
    };
    CommunityEmoteViewer.propTypes = {
        componentData: PropTypes.object.isRequired,
        theme: PropTypes.object,
    };
    return CommunityEmoteViewer;
}(React.Component));
export { OfficialEmoteViewer, CommunityEmoteViewer };
//# sourceMappingURL=ReactViewer.js.map